import React from 'react';
import { Link } from 'react-router-dom';
import { categorias } from '../data/mockData';
import { ArrowRight, Star } from 'lucide-react';

const Home = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title">Mordida de Sonho</h1>
          <p className="hero-subtitle">Sabores que Realizam Sonhos</p>
          <p className="hero-description">
            Pastelaria artesanal portuguesa com receitas tradicionais e ingredientes frescos
          </p>
          <Link to="/produtos" className="hero-btn">
            Ver Produtos
            <ArrowRight size={20} />
          </Link>
        </div>
      </section>

      {/* Destaques */}
      <section className="destaques-section">
        <div className="container">
          <div className="destaques-grid">
            <div className="destaque-card">
              <Star className="destaque-icon" />
              <h3>Qualidade Premium</h3>
              <p>Ingredientes selecionados e frescos</p>
            </div>
            <div className="destaque-card">
              <Star className="destaque-icon" />
              <h3>Tradição Portuguesa</h3>
              <p>Receitas transmitidas por gerações</p>
            </div>
            <div className="destaque-card">
              <Star className="destaque-icon" />
              <h3>Feito com Amor</h3>
              <p>Cada produto é uma obra de arte</p>
            </div>
          </div>
        </div>
      </section>

      {/* Categorias */}
      <section className="categorias-section">
        <div className="container">
          <h2 className="section-title">Nossas Categorias</h2>
          <div className="categorias-grid">
            {categorias.map((categoria) => (
              <Link
                key={categoria.id}
                to={`/produtos?categoria=${categoria.id}`}
                className="categoria-card"
              >
                <div className="categoria-imagem-container">
                  <img
                    src={categoria.imagem}
                    alt={categoria.nome}
                    className="categoria-imagem"
                  />
                  <div className="categoria-overlay"></div>
                </div>
                <div className="categoria-conteudo">
                  <h3 className="categoria-nome">{categoria.nome}</h3>
                  <p className="categoria-descricao">{categoria.descricao}</p>
                  <span className="categoria-link">
                    Ver Mais <ArrowRight size={16} />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Encomende Seus Bolos Personalizados</h2>
            <p>Criamos bolos únicos para aniversários, casamentos e eventos especiais</p>
            <Link to="/contato" className="cta-btn">
              Entre em Contato
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
